import React, { useState } from 'react';
import { motion, Reorder } from 'framer-motion';
import { GripVertical, Plus, Trash2, Type, Hash, Calendar, CheckSquare } from 'lucide-react';
interface Field {
  id: string;
  type: string;
  label: string;
  required: boolean;
}
export function FormBuilder() {
  const [fields, setFields] = useState<Field[]>([{
    id: '1',
    type: 'text',
    label: 'Full Name',
    required: true
  }, {
    id: '2',
    type: 'text',
    label: 'Email Address',
    required: true
  }, {
    id: '3',
    type: 'number',
    label: 'Phone Number',
    required: true
  }]);
  const addField = (type: string) => {
    const newField = {
      id: Date.now().toString(),
      type,
      label: 'New Field',
      required: false
    };
    setFields([...fields, newField]);
  };
  const removeField = (id: string) => {
    setFields(fields.filter(f => f.id !== id));
  };
  const getIcon = (type: string) => {
    switch (type) {
      case 'text':
        return <Type className="h-4 w-4" data-id="element-490" />;
      case 'number':
        return <Hash className="h-4 w-4" data-id="element-491" />;
      case 'date':
        return <Calendar className="h-4 w-4" data-id="element-492" />;
      case 'checkbox':
        return <CheckSquare className="h-4 w-4" data-id="element-493" />;
      default:
        return <Type className="h-4 w-4" data-id="element-494" />;
    }
  };
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-495">
      {/* Field Palette */}
      <div className="lg:col-span-1 bg-white rounded-xl border border-gray-200 p-4 h-fit" data-id="element-496">
        <h3 className="text-sm font-semibold text-gray-900 mb-4" data-id="element-497">
          Form Fields
        </h3>
        <div className="grid grid-cols-2 gap-2" data-id="element-498">
          {['text', 'number', 'date', 'checkbox', 'file', 'dropdown'].map(type => <button key={type} onClick={() => addField(type)} className="flex items-center justify-center p-3 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-200 hover:text-blue-600 transition-colors text-sm capitalize" data-id="element-499">
                {getIcon(type)}
                <span className="ml-2" data-id="element-500">{type}</span>
              </button>)}
        </div>
      </div>

      {/* Canvas */}
      <div className="lg:col-span-2 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300 p-6 min-h-[500px]" data-id="element-501">
        <Reorder.Group axis="y" values={fields} onReorder={setFields} className="space-y-3" data-id="element-502">
          {fields.map(field => <Reorder.Item key={field.id} value={field} data-id="element-503">
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex items-center group" data-id="element-504">
                <GripVertical className="h-5 w-5 text-gray-400 cursor-grab mr-3" data-id="element-505" />
                <div className="flex-1" data-id="element-506">
                  <input type="text" value={field.label} onChange={e => {
                const newFields = fields.map(f => f.id === field.id ? {
                  ...f,
                  label: e.target.value
                } : f);
                setFields(newFields);
              }} className="block w-full border-none p-0 text-sm font-medium focus:ring-0" data-id="element-507" />
                  <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-508">
                    <span className="capitalize" data-id="element-509">{field.type}</span>
                    <span className="mx-2" data-id="element-510">•</span>
                    <label className="flex items-center cursor-pointer" data-id="element-511">
                      <input type="checkbox" checked={field.required} onChange={() => {
                    const newFields = fields.map(f => f.id === field.id ? {
                      ...f,
                      required: !f.required
                    } : f);
                    setFields(newFields);
                  }} className="h-3 w-3 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-512" />
                      <span className="ml-1" data-id="element-513">Required</span>
                    </label>
                  </div>
                </div>
                <button onClick={() => removeField(field.id)} className="p-2 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-514">
                  <Trash2 className="h-4 w-4" data-id="element-515" />
                </button>
              </div>
            </Reorder.Item>)}
        </Reorder.Group>

        {fields.length === 0 && <div className="h-full flex flex-col items-center justify-center text-gray-400 mt-20" data-id="element-516">
            <Plus className="h-12 w-12 mb-2" data-id="element-517" />
            <p data-id="element-518">Add fields from the palette</p>
          </div>}
      </div>
    </div>;
}